import { Input, Span } from '@fareye/ui'
import { getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { formatters } from '../../../config/constants'
import { ColFullHeight } from '../../../style/styled'
import { IColumnConfig } from '../../../utility/types'

function normalizeCellValue(value: any) {
  if (value === null || value === undefined) {
    return '-'
  }
  if (React.isValidElement(value)) {
    return value
  }
  if (Array.isArray(value)) {
    return value.length
      ? value
          .map(item =>
            typeof item === 'object' ? JSON.stringify(item) : String(item)
          )
          .join(', ')
      : '-'
  }
  if (typeof value === 'object') {
    return JSON.stringify(value)
  }
  return value
}

function generateColumnObject(column: IColumnConfig, propsConfig: any) {
  //TODO: Add Tracking column
  let { label, key, formatter, link = '' } = column
  let isNotClickable: boolean = !link
  link = link || '/in-transit/trips'
  //   NOTE: Remove this code once subtype is resolved
  const isMobi = location?.pathname.includes('/v2/view')
  link = isMobi ? (link = `/v2/view${link}`) : link
  const { t } = propsConfig
  switch (key) {
    case 'referenceNo':
      return {
        Header: t(label),
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="referenceNo|slug">
            {isNotClickable ? (
              <Span>{original.referenceNo}</Span>
            ) : (
              <a target="_blank" href={`${link}/${original['slug']}`}>
                {original.referenceNo}
              </a>
            )}
          </ColFullHeight>
        )
      }
    case 'radio':
      return {
        Header: t(label),
        id: key,
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          return (
            <Input
              onChange={() => {
                propsConfig?.setSelectedAlert(original)
              }}
              checked={original.id === propsConfig.selectedAlert?.id}
              name={key}
              type="radio"
              id={key}
            />
          )
        }
      }

    default:
      return {
        Header: t(label),
        id: key,
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          const formattedValue =
            formatter && formatters[formatter]
              ? formatters[formatter](value)
              : value
          const cellValue = normalizeCellValue(formattedValue)
          return (
            <ColFullHeight data-testid={key}>
              <Span variant="ellipsis">
                {cellValue}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumnConfig[],
  propsConfig?: any
) {
  const COLUMNS = reqdColumns.map(ele => generateColumnObject(ele, propsConfig))

  //const result = COLUMNS.filter(column => reqdColumns.includes(column.id))
  return COLUMNS
}
